import * as React from 'react';
import { NavLink } from 'react-router-dom';
import { default as SiteMenu, linkTypes, SiteMenuProps } from './SiteMenu';
import { Col, Row, Typography } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { Contract, User } from 'tree-wallet-client';
import { GlobalContext } from '../../Contexts/GlobalContext';
import MenuContractSelector from './MenuContractSelector';
import { lockPageScroll, unlockPageScroll } from '../../Helper/ScrollLock';
import { BUILD_STAMP } from '../../Service/ConfigurationService';


const { Title } = Typography;

// Copied to dist/icons by CopyPlugin: importing it here would emit a second, identical 58 KB file.
const logo = '/dist/icons/usf-logo-blue.png';

export default class MobileMenu extends SiteMenu {
  static contextType = GlobalContext;
  declare context: React.ContextType<typeof GlobalContext>;

  // The drawer is a fixed overlay: freeze the page behind it while it is open
  componentDidUpdate(_prevProps: SiteMenuProps, prevState: { opened: boolean }) {
    if (prevState.opened === this.state.opened) return;
    if (this.state.opened) lockPageScroll();
    else unlockPageScroll();
  }

  componentWillUnmount() {
    if (this.state.opened) unlockPageScroll();
  }

  async saveOffline() {
    this.toggle();
    await super.saveOffline();
  }

  // Tapping a link closes the drawer before the route changes: 
  // a link that leads to the page already on screen closes the Left-Menu
  protected async followMenuLink(event: React.MouseEvent, navigate: any, to: string) {
    if (this.state.opened) {
      this.toggle();
    }

    await super.followMenuLink(event, navigate, to);
  }

  async downloadkmlfile(navigate?: any) {
    this.toggle(); // Keep toggle for mobile menu
    await super.downloadkmlfile(navigate);
  }

  render() {
    const { opened } = this.state;
    const { user, contract } = this.context;
    // Only the links this user actually sees are counted (see `few-links` in the styles)
    const shownLinks = this.getLinks().filter((link: any) => this.shouldDisplayLink(user, contract, link));

    return <div className='menu mobile'>
      <div className={'mobile-menu-toggle'}>
        <img onClick={this.toggle} src={logo} alt="my image" />
      </div>
      {/* A tap anywhere behind the open drawer closes it */}
      {opened && <div className='mobile-menu-backdrop' onClick={this.toggle} />}
      <nav className={'nav' + (opened ? ' expanded' : '')}>
        {/* Logo left, the close button centred in the room it leaves (see the styles) */}
        <div className='mobile-menu-header'>
          <img className={'nav-logo'} src={logo} />
          <button type='button' className='menu-close' aria-label='Close' title='Close' onClick={this.toggle}>
            <CloseOutlined />
          </button>
        </div>
        <Row style={{ textAlign: 'center', margin: '20px 0', visibility: 'hidden', display: 'none' }}>
          <Col span={18} offset={3}>
            <div><Title level={4} style={{ color: 'white' }}>Current contract</Title></div>
            <div><MenuContractSelector /></div>
          </Col>
        </Row>
        <Row className='mobile-menu-links'>
          <Col span={24}>
            {/* No margin of its own: the links are centred in the room between the logo and the build label below,
                which the flex column shares out (see the menu's styles) */}
            <ul className={shownLinks.length <= 4 ? 'few-links' : undefined} style={{ width: '100%', textAlign: 'center', margin: 0 }}>
              {shownLinks.map((link: any) => this.renderLink(user, contract, link))}
            </ul>
          </Col>
        </Row>
        <div id={'mobile-version-number'}>
          <div>TreeWallet Build<br />{BUILD_STAMP}</div>
        </div>
      </nav>
    </div>
  }

  renderLink(user: User | undefined, contract: Contract | undefined, link: any) {
    const { navigate } = this.context;

    if (!this.shouldDisplayLink(user, contract, link)) {
      return null;
    }

    const template = (link: any) => {
      const linkProps = { style: { color: '#fff' }, className: 'menu-link' };
      switch (link.type) {
        case linkTypes.logout:
          return <NavLink to={'/'} onClick={() => link.onClick(navigate)}>{link.text}</NavLink>;
        case linkTypes.btn:
          return <span {...linkProps} onClick={() => link.onClick()}>{link.text}</span>;
        default:
          return <NavLink {...linkProps} to={link.link}
            onClick={(event) => this.followMenuLink(event, navigate, link.link)}>{link.text}</NavLink>;
      }
    }

    return (
      <li key={"1" + link.link} className={'menu-link'}>
        {link && template(link)}
      </li>
    );
  }
}